import React, { useState, useEffect } from 'react';
//*** Load ESM ArcGIS modules from @arcgis/core
//    This pattern replaces the loading of AMD modules using esri-loader, which is depricated
//*********************************************** */
import esriConfig from "@arcgis/core/config.js";
import Graphic from "@arcgis/core/Graphic.js";
import Point from "@arcgis/core/geometry/Point.js";
import SpatialReference from "@arcgis/core/geometry/SpatialReference.js";
import CIMSymbol from "@arcgis/core/symbols/CIMSymbol.js";
import BasePoint from "./CIM_base_pt.json";
import ConfirmPoint from "./CIM_confirm_pt.json";
import PendingPoint from "./CIM_pending_pt.json";
import NWBPoint from "./CIM_nwb_pt.json";
import SelectedPoint from "./CIM_selected_pt.json";
import SelectedConfirmPoint from "./CIM_selected_confirm_pt.json";
import SelectedPendingPoint from "./CIM_selected_pending_pt.json";
import SelectedNWBPoint from "./CIM_selected_nwb_pt.json";
import PopupTemplate from "@arcgis/core/PopupTemplate.js";
import esriRequest from "@arcgis/core/request.js";
import WebMap from "@arcgis/core/WebMap.js";
import * as geometryEngine from "@arcgis/core/geometry/geometryEngine.js";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer.js";
import GeoJSONLayer from "@arcgis/core/layers/GeoJSONLayer.js";
import Field from "@arcgis/core/layers/support/Field.js";
import ExpressionInfo from "@arcgis/core/form/ExpressionInfo.js";
import FieldInfo from "@arcgis/core/popup/FieldInfo.js";
import * as geoprocessor from "@arcgis/core/rest/geoprocessor.js";
import MapView from "@arcgis/core/views/MapView.js";
import BasemapToggle from "@arcgis/core/widgets/BasemapToggle.js";
import ScaleBar from "@arcgis/core/widgets/ScaleBar.js";
import togeojson from '@mapbox/togeojson';
import JSZip from 'jszip';
import { arcgisToGeoJSON } from '@esri/arcgis-to-geojson-utils';
import { BrowserRouter as Router, Route, Switch, Link } from 'react-router-dom';
import { Nav, Card, ListGroup, Form, Button } from "react-bootstrap";
import styled from 'styled-components';
import { LegendDesign } from '../components/Tabs/LegendDesign';
import { Uploadbutton } from '../components/Tabs/uploadbutton';
import $, { data } from 'jquery';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bs-stepper/dist/css/bs-stepper.min.css';
import Stepper from 'bs-stepper';
import LoginService from "../services/login.service";
import axios from 'axios';
//****IMPORTANT****: 
// BUILD REACT
// npm run build (same as npm run-script build) => no watch
// npm run watch => build and watch
// (1) import correct env config: Config_UAT.json or Config_PROD.json
// (2) main/webapp/WEB-INF/classes/proxy.config => replace content with proxy-prod.config (PROD) or proxy-uat.config  (UAT)
//***************/
import { Certify } from './Certify.mjs';
import { UpdateWwtp } from './UpdateWwtp.mjs';
import { AddWwtp } from './AddWwtp.mjs';
import { DeleteWwtp } from './DeleteWwtp.mjs';
import Expand from "@arcgis/core/widgets/Expand.js";

let Config;
let domain = window.location.hostname;
if ( domain.includes('localhost') || domain.includes('s4ldev') || domain.includes('s4luat') ) 
  Config = require('./Config_UAT.json');
else
  Config = require('./Config_PROD.json');
 
const moment = require('moment-timezone');
const Styles = styled.div`
body{
  min-height:1400px;
}
.card{
    position:absolute !important;
    right:0 !important;
    height:100%;
    width:35%;
}
i.fas.fa-arrow-circle-right{
    /* position: absolute;*/
    font-size: 60px;
    color: #007bff;
    margin-top: 50px;
    bottom: 100px;
    cursor: pointer;

}
#test{
  border: 4px solid #007bff;
    display: inline-block;
    padding: 12px 28px;
    cursor: pointer;
    color: #f2f5f9;
    font-size: 20px;
    margin-top: 30px;
    background-color: #007bff;

}
#cerify{
    border: 4px solid #999999;
    display: inline-block;
    padding: 12px 28px;
    color: #f2f5f9;
    font-size: 20px;
    margin-top: 30px;
    background-color: #999999;
}
i.fas fa-plus{
  margin-right:10px;
}
#titleappend{
  display: inline-block;
  margin: 0;
}
button.step-trigger {
  pointer-events: none !important;
}
b.submit-button {
    border: 4px solid #007bff;
    display: inline-block;
    padding: 12px 28px;
    cursor: pointer;
    color: #f2f5f9;
    font-size: 20px;
    margin-top: 30px;
    background-color: #007bff;
}
b.submit-button-disable {
    border: 4px solid #999999;
    display: inline-block;
    padding: 12px 28px;
    color: #f2f5f9;
    font-size: 20px;
    margin-top: 30px;
    background-color: #999999;
}
`;

export class WebMapView extends React.Component {
  constructor(props) {
    super(props);
    console.log(props);
    this.toggleConsent = this.toggleConsent.bind(this); 
    this.toggleConsentWwtp = this.toggleConsentWwtp.bind(this);
    this.changeWwtp = this.changeWwtp.bind(this);
    this.selectCP = this.selectCP.bind(this);
    this.checkSubmit = this.checkSubmit.bind(this);
    this.mapRef = React.createRef();
    this.state = {
      action: localStorage.getItem("action"),
      userRole: localStorage.getItem("userRole"),
      features: null,
      selectedFeatureGraphic: null,
      selectedFile: null,
      validFile: false,
      validated: false,
      jobMessge: '',
      jobStatus: '',
      validateMessage: '',
      reportId:'',
      reportLink:'',
      reportYear:'',
      reportType:'',
      noWwtpInside:'',
      wwtpData: ([
        {
         "attributes": {
          "OBJECTID": 164,
          "CS_WDID": "6SSO11425",
          "SANITORY_SEWER_SYSTEM_NAME": "Victorville SD CS",
          "WWTP_WDID": "6B360109001",
          "WWTP_FACILITY": "Victor Valley Wastewater Reclamation Authority WTP",
          "WWTP_LATITUDE": 34.618009,
          "WWTP_LONGITUDE": -117.357746
         }
        },
        {
         "attributes": {
          "OBJECTID": 165,
          "CS_WDID": "6SSO11425",
          "SANITORY_SEWER_SYSTEM_NAME": "Victorville SD CS",
          "WWTP_WDID": "6B360911001",
          "WWTP_FACILITY": "SCLA Central WWTP-Victorville Water Dist",
          "WWTP_LATITUDE": 34.614722,
          "WWTP_LONGITUDE": -117.373056
         }
        }
       ]),
      properties: {
        "boundary_type": '',
        "verified_status": 'Pending',
        "verified_name": '',
        "verified_type": '',
        "dt_verified": ''
      }
    };
   }

  formatDate = (date) => {
    if (date === undefined || date === null) {
      return undefined;
    } else {
      return moment(date).format('YYYY-MM-DD');
    }
  };
  formatDateMMDDYYYY = (date) => {
    if (date === undefined || date === null) {
      return undefined;
    } else {
      return moment(date).format('MM/DD/YYYY');
    }
  };
  pacificTimeOfDate = (d = null) => { //don't pass param for now =>pacificTimeOfDate() 
    if (!d) {
      d = new Date();
    }
    return moment(d).tz('America/Los_Angeles').toDate();
  };

  componentDidMount() {
    const s4lUser = JSON.parse(localStorage.getItem('s4l'));
    const today = new Date();
    const formattedDate = new Intl.DateTimeFormat('en-US', {
          month: '2-digit',
          day: '2-digit',             
          year: 'numeric',
          hour: "numeric",
          minute: "numeric",
          second: "numeric"
    }).format(today);
    const epochTime = today.getTime();

    let that = this;
    let tokenExpiration = null;
    let lastGoodToken = null; 

      let portalUrl = Config.server.portalUrl;
      let serverUrl = Config.server.serverUrl;
      let apiKey = Config.server.apiKey;

      let layerPortalItem = Config.server.layerPortalItem;
      let mapPortalItem = Config.server.mapPortalItem;
      let toolsPortalItem = Config.server.toolsPortalItem;
      let wwtpTablePortalItem = Config.server.wwtpTablePortalItem;
      let csTablePortalItem = Config.server.csTablePortalItem;
      let mapServicePortalItem = Config.server.mapServicePortalItem;
      let wwtpFeaturePortalItem = Config.server.wwtpFeaturePortalItem;
      let wwtpArchivePortalItem = Config.server.wwtpArchivePortalItem;
      let csLayerArchivePortalItem = Config.server.csLayerArchivePortalItem;
            
      // JK: ESRI moving from tokens to API Key, but API key currently (JSAPI v.4.31) not working.
      // JK: ESRI provide interceptRequests workaround which appends token to requests directed to URLs listed in requestUrl
      // JK: TODO: replace proxy with API Key
      //esriConfig.apiKey = Config.server.apiKey;
      
     const requestUrl = [`${portalUrl}/sharing/rest/content/items/${layerPortalItem}`, 
        `${portalUrl}/sharing/rest/content/items/${mapPortalItem}`, 
        `${portalUrl}/sharing/servers/${toolsPortalItem}`,
        `${portalUrl}/sharing/servers/${wwtpTablePortalItem}`,
        `${portalUrl}/sharing/servers/${layerPortalItem}`,
        `${portalUrl}/sharing/servers/${csTablePortalItem}`,
        `${portalUrl}/sharing/servers/${wwtpFeaturePortalItem}`,
        `${portalUrl}/sharing/servers/${wwtpArchivePortalItem}`,
        `${portalUrl}/sharing/servers/${csLayerArchivePortalItem}`,
        `${portalUrl}/sharing/rest/content/items/${mapServicePortalItem}`,
        `${portalUrl}/sharing/rest/content/features/generate`,
        `${portalUrl}/sharing/servers/${mapServicePortalItem}`];

      function interceptRequests(requests, token) {
        esriConfig.request.interceptors.push({
          urls: requests,
          before: (params) => {
            params.requestOptions.query.token = token
          }
        })
      }

      esriConfig.portalUrl = portalUrl;
      interceptRequests(requestUrl, apiKey);
           
      // Set the template for the map popup
      const s4lTemplate = new PopupTemplate({
        title: "WDID: {CS_WDID} ",
        content: [{
          type: "fields",
          fieldInfos: [           
            new FieldInfo({
              fieldName: "UPLOAD_DATE",
              label: "UPLOAD_DATE",
              format: { dateFormat: "short-date" }
            }),
            new FieldInfo({
              fieldName: "UPLOAD_USER",
              label: "UPLOAD_USER"
            }),
            new FieldInfo({
              fieldName: "CERTIFIED_YN",
              label: "CERTIFIED_YN"
            }),
            new FieldInfo({
              fieldName: "CERTIFIED_DATE",
              label: "CERTIFIED_DATE",
              format: { dateFormat: "short-date" }
            }),
            new FieldInfo({
              fieldName: "CERTIFIED_USER",
              label: "CERTIFIED_USER"
            }),
            new FieldInfo({
              fieldName: "REVIEW_STATUS",
              label: "REVIEW_STATUS"
            }),
            new FieldInfo({
              fieldName: "REVIEW_DATE",
              label: "REVIEW_DATE",
              format: { dateFormat: "short-date" }
            }),
            new FieldInfo({
              fieldName: "REVIEW_USER",
              label: "REVIEW_USER"
            })]
        }]
      });

      const map = new WebMap({
        portalItem : {id: Config.server.mapPortalItem},
        basemap: "streets"
      });

      map.load() // for debugging. Map fails to load the first time possibly due to sleeping services. Loads fine after refresh.
        .then(function () {
          // the webmap successfully loaded   
          var s4lLayer = map.findLayerById(Config.server.boundaryLayerId);
          s4lLayer.definitionExpression =  "CS_WDID = '{CS_WDID}'".replace('{CS_WDID}', localStorage.getItem('s4l_wdid'));
          s4lLayer.refresh();                
          console.log("Map: ", map)
        })
        .catch(function (error) {
          // the webmap or portal failed to load
          console.log("The resource failed to load: ", error);
          map.load()
            .then(function () {
              // the webmap successfully loaded
              var s4lLayer = map.findLayerById(Config.server.boundaryLayerId);
              s4lLayer.definitionExpression =  "CS_WDID = '{CS_WDID}'".replace('{CS_WDID}', localStorage.getItem('s4l_wdid'));
              s4lLayer.refresh();
              console.log("The map successfully to load.");
            })
            .catch(function (error) {
              // the webmap or portal failed to load
              console.log("The resource failed to load second time: ", error);
            });
        });

      this.view = new MapView({ // default map
        container: this.mapRef.current,
        map: map,
        center: [-118, 37.1],
        zoom: 6.99,
        popup: {
          defaultPopupTemplateEnabled: true
          //,collapseEnabled: true
        }
      });

      this.stepper = new Stepper(document.querySelector('#stepper1'), {
        linear: false,
        animation: true
      })

      const scaleBar = new ScaleBar({
        style: "line",
        unit: "dual",
        view: this.view
      });
      this.view.ui.add(scaleBar, { position: "bottom-left" });

      const bmaps = new BasemapToggle({
        view: this.view,
        nextBasemap: "hybrid"
      });
      this.view.ui.add(bmaps, { position: "bottom-right" });

      this.view.when(this.onViewLoaded)
       .then(() => {
      //View
      const view = this.view;
      //Feature layer goes here
      const s4lmainlayer = new FeatureLayer({url:`${portalUrl}/sharing/servers/${Config.server.layerPortalItem}/rest/services/S4L/S4L_CS_Boundaries/FeatureServer/1`});
      console.log("s4lmainlayer: ", s4lmainlayer)
      s4lmainlayer.definitionExpression = "CS_WDID = '{CS_WDID}'".replace('{CS_WDID}', localStorage.getItem('s4l_wdid'));
      s4lmainlayer.popupTemplate = s4lTemplate;

      //If s4l_wdid exits show feature on map
      var query = s4lmainlayer.createQuery();
      let qs = "CS_WDID = '{CS_WDID}'";
      query.where = qs.replace('{CS_WDID}', localStorage.getItem('s4l_wdid'));   
      query.returnGeometry = true;
      s4lmainlayer.queryFeatures(query)
        .then(function (featureSet) {
          if (featureSet && featureSet.features && featureSet.features[0]) {
            console.log(featureSet.features[0].attributes);
            // that.setState({ features: featureSet.features, properties:{verified_status:'Pending'}});
            let feature1 = featureSet.features[0]; 
            that.setState({
              features: featureSet.features,
              selectedFeatureGraphic: featureSet.features[0],
              s4lmainlayer: s4lmainlayer,
              view: view
            });
            console.log("Open popup");
            console.log(view);
            view.openPopup({
               features: featureSet.features,
               featureMenuOpen: true
             });
            console.log("Popup opened");
            const featGeoms = featureSet.features.map(f => f.geometry);
            const funion = geometryEngine.union(featGeoms);
            // Per ESRI Extent docs, expand should be done on a clone of an extent, not original.
            const funion2 = funion.extent.clone().expand(2);
            view.goTo(funion2, {animate: false}); //zoom to slightly expanded view of features
          }
          else {
            that.setState({ action: 'Upload', validated: false });
          }
      });

      function uploadFile (fileName, that, files) {
        // Create an object of formData 
        const formData = new FormData();
        // Update the formData object 
        formData.append(
          "f", "json"
        );
        formData.append(
          "file",
          files[0],
          files[0].name
        );
        formData.append(
          "token", apiKey
        );
        let serverUrl = Config.server.serverUrl;

        axios.post(`${portalUrl}/sharing/servers/${Config.server.toolsPortalItem}/rest/services/S4L/S4L_Tools/GPServer/uploads/upload`, formData).then(function (response) {
          console.log('upload shapefile');
          console.log(response);
          itemID = response.data.item.itemID;
          // Validate file
          const gpUrl = `${portalUrl}/sharing/servers/${Config.server.toolsPortalItem}/rest/services/S4L/S4L_Tools/GPServer/ValidateFeature`;
          const paramsShapefile = {
            //in_attr: that.state.action == "Upload"?  "Add": that.state.action,
            in_file: { "itemID": itemID },
            token: apiKey,
            // in_json_str: JSON.stringify(geoJsonObject.features[0].properties) //shapefile expected input param structure is different
          };
          console.log(paramsShapefile);
          geoprocessor.submitJob(gpUrl, paramsShapefile).then((jobInfo) => {
            var jobid = jobInfo.jobId;
            that.setState({ jobStatus: 'pending', validateFileMessage: (/*'Processing Append Job ID ' + jobid + */ ' Validate map file is in progress.') });
            console.log('jobid=' + jobid);
            //function to write status to console
            const statusOpts = {
              statusCallback: (jobInfo1) => {
                console.log(`Job ID ${jobid}: ${jobInfo1.jobStatus}`);
              }
            };
            jobInfo.waitForJobCompletion(statusOpts).then((jobInfo2) => {                              
                  if (fileName.indexOf(".zip") !== -1) {
                    generateFeatureCollection(fileName);
                  }
                  else if (fileName.indexOf(".kmz") !== -1) {
                    selectedFilename = 'KMZ';
                    generatekmztoFeatureCollection(files, this);
                  } 
                  else {
                    selectedFilename = 'KMZ';
                    generatekmltoFeatureCollection (files);
                  } 
                  console.log('Validate File Suscessfully: ', jobInfo2);
                  that.setState({
                    selectedFile: files[0], validFile: true,
                  });                                   
            }).catch((error) => {
              console.log('Upload File Error: ', error);
              that.setState({  
                              selectedFile: null, validFile: false,
                            }); 
              let gisError = ''; 
              error.messages.map((item) => (
                gisError += ( (item.description.substring(0,9) === 'GP_ERROR:') ? item.description.substring(10) : '' )                                        
              ));                                     
              //alert( (error.messages[2].description.substring(0,9) === 'GP_ERROR:') ? error.messages[2].description.substring(10) : '' ); 
              alert( gisError );                        
              that.setState({ jobStatus: 'pending', validateFileMessage: ('') });
            });
          }).catch((error) => {
            that.setState({  
                            selectedFile: null, validFile: false,
                          });                                     
            alert( 'The upload portal is currently offline for maintenance. Please try again later. If the problem persists, please click the "Contact Us" icon in the header.' );                        
            that.setState({ jobStatus: 'pending', validateFileMessage: ('') });
          });
          // end validate file                                 
        })
          .catch(function (error) {
            console.log(error);
        });
      }

      let element = document.getElementById('imageHover');
      element.addEventListener("mouseover",function(){
        const popupWindow = document.getElementById('popupWindow');
        popupWindow.style.display = 'block';
      });
      element.addEventListener("mouseout",function(){
        const popupWindow = document.getElementById('popupWindow');
        popupWindow.style.display = 'none';
      });   

      document
        .getElementById("uploadForm")
        .addEventListener("change", function (event) {
          selectedFilename = 'Shapefile';                                           
          let that = this;
          let fileName = event.target.value.toLowerCase();
          let files = event.target.files;
          if (files.length > 0) {
            uploadFile(fileName, that, files);
          }
        }.bind(this));

      //submit append tool ON CLICK
      let selectedFilename = ''; //Shapefile or KMZ
      let itemID = '';
      let geoJsonObject = {};
      let featureCollection;//for zip & json

      $("#certify").click(function () {
            if (!document.getElementById("consent").checked)  {
                alert('Please check the consent before click certify');
                return false;
            } 
            console.log("Payload:", JSON.stringify(that.state.features[0].attributes));
            let payLoad = [
                            {
                              "attributes":{
                                             "OBJECTID":that.state.features[0].attributes.OBJECTID,
                                             "CERTIFIED_YN":"Y",
                                             "CERTIFIED_DATE":epochTime,
                                             "CERTIFIED_USER": s4lUser.username,
                                             "GLOBALID":that.state.features[0].attributes.GLOBALID
                                           }
                            }
                          ];
            //UplLoadKMZ();
            if (Certify(payLoad, Config)) {
              that.view.closePopup();  
              var query = s4lmainlayer.createQuery();
              let qs = "CS_WDID = '{CS_WDID}'";
              query.where = qs.replace('{CS_WDID}', localStorage.getItem('s4l_wdid'));   
              query.returnGeometry = true;
              s4lmainlayer.queryFeatures(query)
                .then(function (featureSet) {
                  if (featureSet && featureSet.features && featureSet.features[0]) {
                    //console.log(featureSet.features[0].attributes);
                    featureSet.features[0].attributes.CERTIFIED_YN = 'Y';
                    featureSet.features[0].attributes.CERTIFIED_USER = s4lUser.username;
                    featureSet.features[0].attributes.CERTIFIED_DATE = epochTime;
                    that.setState({
                      features: featureSet.features,
                      selectedFeatureGraphic: featureSet.features[0],
                      s4lmainlayer: s4lmainlayer,
                      view: view
                    });
                    console.log("Open popup");
                    console.log(view);
                    view.openPopup({
                       features: featureSet.features,
                       featureMenuOpen: true
                     });
                    //console.log("Popup opened");
                    const featGeoms = featureSet.features.map(f => f.geometry);
                    const funion = geometryEngine.union(featGeoms);
                    const funion2 = funion.extent.clone().expand(2);
                    view.goTo(funion2, {animate: false}); //zoom to slightly expanded view of features
                  }
                  else {
                    that.setState({ action: 'Upload', validated: false });
                  }
              });
              that.setState({ jobStatus: 'complete', jobMessage: 'Congratulations your boundary file was successfully certified to the S4L layer.' });
            }
            else {
              that.setState({ jobStatus: 'complete', jobMessage: 'Unfortunately your boundary file was unsuccessfully certified to the S4L layer.' });
            }            
      });

      $("#wwtpSubmit").click(function () {
            // Call API to save the wwtpData
            let payLoad = [];
            console.log("that.state.wwtpData :", that.state.wwtpData);
            that.state.wwtpData.filter(object => object.status !== 'N').forEach(function(item) {
              console.log(item);
              if (item.archive) {
                // copy old record of s4l_wwtp to s4l_wwtp_archive and update archive fields
                  const formData2 = new FormData();
                  formData2.append(
                    "f", "json"
                  );
                  formData2.append(
                    "token", apiKey
                  );
                  qs = "CS_WDID = '{CS_WDID}' and WWTP_FACILITY_ID = "+ item.attributes.WWTP_FACILITY_ID;
                  formData2.set(
                    "where", qs.replace('{CS_WDID}', localStorage.getItem('s4l_wdid'))
                  );
                  formData2.set(
                    "outFields", "*"
                  );
                  let getStatus = `${portalUrl}/sharing/servers/${Config.server.wwtpFeaturePortalItem}/rest/services/S4L/S4L_CS_Boundaries/FeatureServer/2/query`;
                  axios.post(`${getStatus}`, formData2).then(function (response2) {
                      console.log('Get old record data from table s4l_wwtp to build payload');
                      // Add record to s4l_wwtp_arcchive  
                      payLoad = [{"attributes":{
                                        "FACILITY_NAME": response2.data.features[0].attributes.FACILITY_NAME,
                                        "CS_WDID": response2.data.features[0].attributes.CS_WDID, 
                                        "LATITUDE": response2.data.features[0].attributes.LATITUDE,
                                        "LONGITUDE": response2.data.features[0].attributes.LONGITUDE, 
                                        "WWTP_WDID": response2.data.features[0].attributes.WWTP_WDID,
                                        "WWTP_FACILITY_ID": response2.data.features[0].attributes.WWTP_FACILITY_ID, 
                                        "STATUS": response2.data.features[0].attributes.STATUS,
                                        "STATUS_DATE": response2.data.features[0].attributes.STATUS_DATE,
                                        "STATUS_USER": response2.data.features[0].attributes.STATUS_USER,
                                        "CERTIFY_DATE": response2.data.features[0].attributes.CERTIFY_DATE,
                                        "CERTIFY_USER": response2.data.features[0].attributes.CERTIFY_USER,
                                        "ARCHIVE_DATE": (new Date()).getTime(),
                                        "ARCHIVE_USER": s4lUser.username
                                      }
                      }]; 
                      if (AddWwtp(payLoad, true, Config)) {            
                         // delete the old record
                         payLoad = [{"attributes":{
                                        "OBJECTID ": response2.data.features[0].attributes.OBJECTID 
                                   }
                         }]; 
                         if (DeleteWwtp(response2.data.features[0].attributes.OBJECTID, Config)) {         
                         } else {
                            alert ('Delete fails' );
                         }                        
                      } else {
                        alert ('Add fails' );
                      }                                          
                  })
                    .catch(function (error) {
                      console.log(error);
                  });                   
              }
              //insert into s4l_wwtp
              payLoad = [{"attributes":{
                                        "FACILITY_NAME": item.attributes.WWTP_FACILITY,
                                        "CS_WDID": item.attributes.CS_WDID, 
                                        "LATITUDE": item.attributes.WWTP_LATITUDE,
                                        "LONGITUDE": item.attributes.WWTP_LONGITUDE, 
                                        "WWTP_WDID": item.attributes.WWTP_WDID,
                                        "WWTP_FACILITY_ID": item.attributes.WWTP_FACILITY_ID, 
                                        "STATUS": (item.status === 'N') ? '' : item.status,
                                        "STATUS_DATE": (new Date()).getTime(),
                                        "STATUS_USER": s4lUser.username
                                      }
                          }];
              if (AddWwtp(payLoad, false, Config)) {            
                that.setState({ jobStatus: 'complete', action: 'WWTP_SAVE_SUCCESS' }); 
              } else {
                alert ('Add fails' );
              }             
            });        
      });

    $("#toCertifyWwtp2").click(function () {
        gotoCertifyWwtp();       
    });

    $("#toCertifyWwtp1").click(function () {
        wwtp (false); 
        // wwtp (true); org  Skip to Cerify WWTP(s)
    });

    function gotoCertifyWwtp () {
      that.setState({ 
        jobStatus: 'complete', 
        action: 'WWTP_CERTIFY' 
       }); 
    }

      $("#certifyWwtp").click(function () {
            if (!document.getElementById("consentWwtp").checked)  {
                alert('Please check the consent before click certify');
                return false;
            } 
            let payLoad = [];
            console.log("that.state.wwtpData :", that.state.wwtpData);
            that.state.wwtpData.filter(object => object.status === 'C').forEach(function(item) {
              console.log(item);
                // copy old record of s4l_wwtp to s4l_wwtp_archive and update archive fields
                  const formData2 = new FormData();
                  formData2.append(
                    "f", "json"
                  );
                  formData2.append(
                    "token", apiKey
                  );
                  qs = "CS_WDID = '{CS_WDID}' and WWTP_FACILITY_ID = "+ item.attributes.WWTP_FACILITY_ID;
                  formData2.set(
                    "where", qs.replace('{CS_WDID}', localStorage.getItem('s4l_wdid'))
                  );
                  formData2.set(
                    "outFields", "*"
                  );
                  let getStatus = `${portalUrl}/sharing/servers/${Config.server.wwtpFeaturePortalItem}/rest/services/S4L/S4L_CS_Boundaries/FeatureServer/2/query`;
                  axios.post(`${getStatus}`, formData2).then(function (response2) {
                      console.log('Get old record data from table s4l_wwtp to build payload');
                      // Add record to s4l_wwtp_arcchive  
                      payLoad = [{"attributes":{
                                        "FACILITY_NAME": response2.data.features[0].attributes.FACILITY_NAME,
                                        "CS_WDID": response2.data.features[0].attributes.CS_WDID, 
                                        "LATITUDE": response2.data.features[0].attributes.LATITUDE,
                                        "LONGITUDE": response2.data.features[0].attributes.LONGITUDE, 
                                        "WWTP_WDID": response2.data.features[0].attributes.WWTP_WDID,
                                        "WWTP_FACILITY_ID": response2.data.features[0].attributes.WWTP_FACILITY_ID, 
                                        "STATUS": response2.data.features[0].attributes.STATUS,
                                        "STATUS_DATE": response2.data.features[0].attributes.STATUS_DATE,
                                        "STATUS_USER": response2.data.features[0].attributes.STATUS_USER,
                                        "CERTIFY_DATE": response2.data.features[0].attributes.CERTIFY_DATE,
                                        "CERTIFY_USER": response2.data.features[0].attributes.CERTIFY_USER,
                                        "ARCHIVE_DATE": (new Date()).getTime(), //epochTime,
                                        "ARCHIVE_USER": s4lUser.username
                                      }
                      }]; 
                      if (AddWwtp(payLoad, true, Config)) {            
                         //Update certify_users and certify_date for the record in s4l_wwtp
                          payLoad = [{"attributes":{
                                                    "OBJECTID": response2.data.features[0].attributes.OBJECTID,
                                                    "GLOBALID": response2.data.features[0].attributes.GLOBALID, 
                                                    "CERTIFY_DATE": (new Date()).getTime(), //epochTime,
                                                    "CERTIFY_USER": s4lUser.username, 
                                                   /*  "STATUS_DATE": epochTime,
                                                    "STATUS_USER": s4lUser.username */
                                                  }
                                      }];
                          if (UpdateWwtp(payLoad, Config)) {            
                              that.setState({ jobStatus: 'complete', action: 'WWTP_CERTIFY_SUCCESS' }); 
                          } else {
                              alert ('Update certify_users and certify_date fails' );
                          }  
                      } else {
                        alert ('Add fails' );
                      }                                          
                  })
                    .catch(function (error) {
                      console.log(error);
                  });             
            });            
      });

      $("#wwtpUpload").click(function () {
          wwtp(false);       
      });

      $("#wwtpCertify").click(function () {
          wwtp(false);     
      });

    function wwtp (fromCertifyCS) {
        // Call GIS WWTP API            
        const formData = new FormData();
        formData.append(
          "f", "json"
        );
        let qs = "CS_WDID = '{CS_WDID}'";
        formData.append(
          "where", qs.replace('{CS_WDID}', localStorage.getItem('s4l_wdid'))
        );
        formData.append(
          "outFields", "*"
        );
        formData.append(
          "token", apiKey
        );
        let wwtpUrl = `${portalUrl}/sharing/servers/${wwtpTablePortalItem}/rest/services/S4L/CIWQS_VIEWS/FeatureServer/2/query`;
        axios.post(`${wwtpUrl}`, formData).then(function (response) {
          console.log('Get WWTP info of a CS_WDID');
          if ( response.data.features.length === 0 )  {
            qs = "WDID = '{CS_WDID}'";
            formData.set(
              "where", qs.replace('{CS_WDID}', localStorage.getItem('s4l_wdid'))
            );
            formData.append(
              "outFields", "SSS_ANNUAL_REPORT_ID,REPORT_YEAR,REPORT_TYPE"
            );
            let wwtpView1 = `${portalUrl}/sharing/servers/${Config.server.csTablePortalItem}/rest/services/S4L/CIWQS_VIEWS/FeatureServer/1/query`;
            axios.post(`${wwtpView1}`, formData).then(function (response) {
              console.log('Get CS info of a CS_WDID');
              console.log(response.data.features);
              if ( response.data.features.length === 0   ||  (response.data.features[0].attributes.SSS_ANNUAL_REPORT_ID === null ) )  {
                 // No annual report found
                 that.setState({ jobStatus: 'complete', action: 'WWTP_NOAR' });
              }
              else {
                 // Annual report found but no WWTP. The API should return reportId and reporrtYear
                 if (response.data.features[0].attributes.SSS_ANNUAL_REPORT_ID !== null )  {
                    let link = "https://ciwqs.waterboards.ca.gov/ciwqs/sso/sssAnnualReportGenInfo.xhtml?sssAnnualReportID=" + response.data.features[0].attributes.SSS_ANNUAL_REPORT_ID +"&module=15";
                    that.setState({ jobStatus: 'complete', action: 'WWTP_AR_NOWWTP', reportId: response.data.features[0].attributes.SSS_ANNUAL_REPORT_ID , reportLink: link , reportYear: response.data.features[0].attributes.REPORT_YEAR, reportType: response.data.features[0].attributes.REPORT_TYPE });
                 }
              }
            })
              .catch(function (error) {
                console.log(error);
            });
          }
          else {
            // Have WWTP. Check all the associcated WWTP is in CS boundary
            response.data.features.forEach(item => {
              item.status = "N";
              item.archive = false;
            });

            //addWwtpLegend();
              const legendBox = new Expand();
              const legend = document.createElement('img');
              legend.src = "./wwtp_legend.png";
              legend.alt = "WWTP legend";
              legendBox.content = legend;
              legendBox.expand();
              view.ui.add(legendBox, {position: "top-left"});

            //console.log(response.data.features, 'After add');
            let nothingInsideCS = true;
            let features = response.data.features;
            that.view.closePopup(); 
            let g = new Graphic(
                  {geometry: new Point({x: 0, 
                                        y: 0,
                                        spatialReference: SpatialReference.WGS84}),
                    attributes: {"id": 0, "wwtp_facility_id": 0, "cs_wdid": '', "name": ''},
                    symbol: new CIMSymbol({data: PendingPoint})
                  }
            );
            that.setState({ wwtpData:response.data.features });
            for (let i = 0; i < features.length; i++) {
              console.log('-----------------');
              console.log(' i = ', i, ', data = ' , features[i]);
              let WWTP_FACILITY_ID = features[i].attributes.WWTP_FACILITY_ID;
              let CS_WDID = features[i].attributes.CS_WDID;
              let WWTP_LONGITUDE = features[i].attributes.WWTP_LONGITUDE;
              let WWTP_LATITUDE = features[i].attributes.WWTP_LATITUDE;

              formData.set(
                "where", "CS_WDID = '{CS_WDID}'".replace('{CS_WDID}', CS_WDID)
              );
              formData.append(
                "geometry", "'{WWTP_LONGITUDE}','{WWTP_LATITUDE}'".replace('{WWTP_LONGITUDE}', WWTP_LONGITUDE).replace('{WWTP_LATITUDE}', WWTP_LATITUDE)
              ); 
              formData.append(
                "geometryType", "esriGeometryPoint"
              );
              formData.append(
                "inSR", "4326"
              );
              formData.append(
                "spatialRel", "esriSpatialRelIntersects"
              );
              formData.append(
                "units", "esriSRUnit_Foot"
              );
              formData.append(
                "returnGeometry", "false"
              );
              formData.append(
                "returnDistinctValues", "false"
              );
              console.log('Check if a WWTP is inside of a CS_WDID');
              let checkInside = `${portalUrl}/sharing/servers/${Config.server.layerPortalItem}/rest/services/S4L/S4L_CS_Boundaries/FeatureServer/1/query`;
              axios.post(`${checkInside}`, formData).then(function (response1) {  
              if ( response1.data.features.length !== 0  /* || ( i === 0 ) */ ) {
                  console.log(WWTP_FACILITY_ID, ' is inside CS boundary');
                  nothingInsideCS = false;
                  // if the WWTP is inside, get status from S4L_WWTP
                  const formData2 = new FormData();
                  formData2.append(
                    "f", "json"
                  );
                  formData2.append(
                    "token", apiKey
                  );
                  qs = "CS_WDID = '{CS_WDID}' and WWTP_FACILITY_ID = "+ WWTP_FACILITY_ID;
                  formData2.set(
                    "where", qs.replace('{CS_WDID}', localStorage.getItem('s4l_wdid'))
                  );
                  formData2.set(
                    "outFields", "*"
                  );
                  let getStatus = `${portalUrl}/sharing/servers/${Config.server.wwtpFeaturePortalItem}/rest/services/S4L/S4L_CS_Boundaries/FeatureServer/2/query`;
                  axios.post(`${getStatus}`, formData2).then(function (response2) {
                    console.log('Get wwtp status from table s4l_wwtp');
                    if ( response2.data.features.length === 0 )  {
                      console.log('No record in s4L_wwtp and returned status is P default for WWTP_FACILITY_ID = ', WWTP_FACILITY_ID);
                      features[i].archive = false;
                      features[i].status = 'P';
                      g = new Graphic(
                        {geometry: new Point({x: WWTP_LONGITUDE, 
                                              y: WWTP_LATITUDE,
                                              spatialReference: SpatialReference.WGS84}),
                          attributes: {"id": features[i].attributes.OBJECTID, "wwtp_facility_id": WWTP_FACILITY_ID, "cs_wdid": CS_WDID, "name": features[i].attributes.WWTP_FACILITY},
                          symbol: new CIMSymbol({data: PendingPoint}) 
                          }
                        );
                      view.graphics.add(g);                      
                    }
                    else {
                      console.log('Have record in s4L_wwtp and returned status is ' , response2.data.features[0].attributes.STATUS , ' for WWTP_FACILITY_ID = ', WWTP_FACILITY_ID);
                      features[i].archive = true;
                      features[i].status = response2.data.features[0].attributes.STATUS;  
                      if (response2.data.features[0].attributes.STATUS === 'C') 
                      {   
                          g = new Graphic(
                            {geometry: new Point({x: WWTP_LONGITUDE, 
                                                  y: WWTP_LATITUDE,
                                                  spatialReference: SpatialReference.WGS84}),
                              attributes: {"id": features[i].attributes.OBJECTID, "wwtp_facility_id": WWTP_FACILITY_ID, "cs_wdid": CS_WDID, "name": features[i].attributes.WWTP_FACILITY},
                              symbol: new CIMSymbol({data: ConfirmPoint}) 
                              }
                            );
                          view.graphics.add(g);                          
                      } else if (response2.data.features[0].attributes.STATUS === 'P') {
                          g = new Graphic(
                            {geometry: new Point({x: WWTP_LONGITUDE, 
                                                  y: WWTP_LATITUDE,
                                                  spatialReference: SpatialReference.WGS84}),
                              attributes: {"id": features[i].attributes.OBJECTID, "wwtp_facility_id": WWTP_FACILITY_ID, "cs_wdid": CS_WDID, "name": features[i].attributes.WWTP_FACILITY},
                              symbol: new CIMSymbol({data: PendingPoint}) 
                              }
                            );
                          view.graphics.add(g);                          
                      } else {
                          g = new Graphic(
                            {geometry: new Point({x: WWTP_LONGITUDE, 
                                                  y: WWTP_LATITUDE,
                                                  spatialReference: SpatialReference.WGS84}),
                              attributes: {"id": features[i].attributes.OBJECTID, "wwtp_facility_id": WWTP_FACILITY_ID, "cs_wdid": CS_WDID, "name": features[i].attributes.WWTP_FACILITY},
                              symbol: new CIMSymbol({data: NWBPoint}) 
                              }
                            );
                          view.graphics.add(g); 
                      }                                          
                    }
                    //view.goTo(view.graphics);
                    //console.log('Before setState. WWTP = ', features[i].attributes.WWTP_FACILITY, ';i = ' , i, '; view.graphics = ' , view.graphics); 
                    that.setState({ wwtpData:features, noWwtpInside: nothingInsideCS });
                  })
                    .catch(function (error) {
                      console.log(error);
                      return 'P';
                  });            
                }
                else {
                  // Not inside, set status to 'Not within boundary'
                  console.log(WWTP_FACILITY_ID, ' is outside CS boundary');
                  features[i].status = 'N';  
                  g = new Graphic(
                    {geometry: new Point({x: WWTP_LONGITUDE, 
                                          y: WWTP_LATITUDE,
                                          spatialReference: SpatialReference.WGS84}),
                      attributes: {"id": features[i].attributes.OBJECTID, "wwtp_facility_id": WWTP_FACILITY_ID, "cs_wdid": CS_WDID, "name": features[i].attributes.WWTP_FACILITY},
                      symbol: new CIMSymbol({data: NWBPoint}) 
                      }
                    );
                  view.graphics.add(g);  
                  //view.goTo(view.graphics); 
                  //console.log('Before setState. WWTP = ', features[i].attributes.WWTP_FACILITY, ';i = ' , i, '; view.graphics = ' , view.graphics);           
                  that.setState({ wwtpData:features, noWwtpInside: nothingInsideCS });        
                }
              })
                .catch(function (error) {
                  console.log(error);
                  return 'P';
              });  
              //view.goTo(view.graphics); // does not focus to WWTPs
            }
            //view.goTo(view.graphics); does not work
            // Be carefull, javacript does this one first during waiting for the result of the axios.post at line 997
            console.log(features, 'features before setState, nothingInsideCS = ' , nothingInsideCS);
            let wwtpAction = 'WWTP';
            if (fromCertifyCS)
              wwtpAction = 'WWTP_SAVE_SUCCESS';
            that.setState({ 
                //wwtpData:features,
                //wwtpStatus: localStatus,
                jobStatus: 'complete', 
                noWwtpInside: nothingInsideCS, // this one is not set !!???
                action: wwtpAction 
            });  
          }                               
        })
          .catch(function (error) {
            console.log(error);
        });
        console.log( 'that.state.wwtpData at the end of wwtp() is ', that.state.wwtpData);
      };

      function addWwtpLegend() {
        const legendBox = new Expand();
        const legend = document.createElement('img');
        legend.src = "./wwtp_legend.png";
        legend.alt = "WWTP legend";
        legendBox.content = legend;
        legendBox.expand();
        this.view.ui.add(legendBox, {position: "top-left"});
      }

      $("#upload").click(function () {
        cleanupGeoJson();
        let isShapefile = selectedFilename === 'Shapefile';
        isShapefile = true; // upload file for both kmz and shapefile
        const gpUrl = `${portalUrl}/sharing/servers/${Config.server.toolsPortalItem}/rest/services/S4L/S4L_Tools/GPServer/UploadFeatureToSDE`;
        const params = {
          in_attr: that.state.action == "Upload"?  "Add": that.state.action,
          in_json_str: JSON.stringify(geoJsonObject)
        };
        const paramsShapefile = {
          in_attr: that.state.action == "Upload"?  "Add": that.state.action,
          in_file: { "itemID": itemID },
          token: apiKey,
          in_json_str: JSON.stringify(geoJsonObject.features[0].properties) //shapefile expected input param structure is different
        };

        console.log('geoJsonObject string  before submit');
        console.log(JSON.stringify(geoJsonObject))
        console.log(paramsShapefile);
        geoprocessor.submitJob(gpUrl, isShapefile ? paramsShapefile : params).then((jobInfo) => {
          var jobid = jobInfo.jobId;
          that.setState({ jobStatus: 'pending', jobMessage: ('Submitting map file is in progress.') });
          console.log('jobid=' + jobid);

          //function to write status to console
          const statusOpts = {
            statusCallback: (jobInfo1) => {
              console.log(`Job ID ${jobid}: ${jobInfo1.jobStatus}`);
            }
          };

          jobInfo.waitForJobCompletion(statusOpts).then((jobInfo2) => {
            that.setState({jobStatus: 'complete',
                            jobMessage: 'Congratulations! Your boundary file was successfully uploaded. It now will need to be verified by a State Board or Local Primacy Agency staff member.'}
             );
          }).catch((error) => {
            console.log(error);
            that.setState({ jobStatus: 'complete', 
                            jobMessage: ('Your boundary file did not upload successfully.  Please try again.'  
                            +'If you continue to have issues, contact us by email at <a href="mailto:S4L-Help@waterboards.ca.gov?subject=Assistance Needed with S4L Upload Issue">S4L-Help@waterboards.ca.gov</a>') });            
          });

        });
      });
      //
      function cleanupGeoJson() { 
        let s4lWdid = localStorage.getItem('s4l_wdid');        
        let geoJson = {
            "type": "FeatureCollection",
            "features": [
              {
                "type": "Feature",
                "geometry": {
                  "type": "Polygon",
                  "coordinates": []
                },
                "properties": {
                  "CS_WDID": "",
                  "UPLOAD_DATE": "",
                  "UPLOAD_USER": "" 
                }
              }
            ]
          }
          let feature = geoJson.features[0];
          feature.properties.CS_WDID = s4lWdid;
          feature.properties.UPLOAD_DATE = formattedDate;
          feature.properties.UPLOAD_USER = s4lUser.username;
          feature.geometry = geoJsonObject && geoJsonObject.features?geoJsonObject.features[0].geometry:null;
          geoJsonObject = geoJson;
          console.log(geoJsonObject);       
      }

      function showKmlKmzOnMap() {
        const blob = new Blob([JSON.stringify(geoJsonObject)], { type: "application/json" });
        const url = URL.createObjectURL(blob);
        const layer = new GeoJSONLayer({ url });
        map.add(layer);
        layer.queryExtent().then(function (results) {
          // go to the extent of the results satisfying the query
          view.goTo(results.extent);
        });
      }

      function generatekmztoFeatureCollection(files, that) {
        let f = files[0];
        let getDom = xml => (new DOMParser()).parseFromString(xml, "text/xml");
        let getExtension = fileName => fileName.split(".").pop();
        let getKmlDom = (kmzFile) => {
          if (f.name.indexOf(".kmz") !== -1) {
              var zip = new JSZip()
              return zip.loadAsync(kmzFile)
                .then(zip => {
                  let kmlDom = null
                  zip.forEach((relPath, file) => {
                    if (getExtension(relPath) === "kml" && kmlDom === null) {
                      kmlDom = file.async("string").then(getDom)
                    }
                  })
                  return kmlDom || Promise.reject("No kml file found")
                });
            } 
            else {
                return f.async("string").then(getDom)
            }
         }        
        
        //let that = this;
        getKmlDom(f).then(kmlDom => {
          geoJsonObject = togeojson.kml(kmlDom);
          console.log('geoJsonObject from togeojson');
          console.log(JSON.stringify(geoJsonObject));
          if (geoJsonObject.features[0].geometry.type === 'GeometryCollection') {
            that.setState({ selectedFile: null, validFile: false });
            alert('KMZ files with multi-part polygons are not supported. Please convert to a Shapefile and try again.');
          }
          else {
            cleanupGeoJson();
            showKmlKmzOnMap();
          }
        });
      }

      //Kml import function
      function generatekmltoFeatureCollection(files) {
        let f = files[0];
        let reader;
        let fsize = f.size;
        let maxSize = 1024 * 1024; // 1mb
        if (fsize > maxSize) {
          alert('File is too big!');
          return;
        }
        reader = new FileReader();
        let that = this;
        reader.onload = function (fe) {
          const kmltest = fe.target.result; // the file
          geoJsonObject = togeojson.kml((new DOMParser()).parseFromString(kmltest, 'text/xml'));
          cleanupGeoJson();
          showKmlKmzOnMap();
        }
        reader.readAsText(f);
      }

      //Shapefile and Geojson import
      function generateFeatureCollection(fileName) {
        let names = fileName.split("\\");
        // Chrome and IE add c:\fakepath to the value - we need to remove it
        // see this link for more info: http://davidwalsh.name/fakepath
        // name = name[0].replace("c:\\fakepath\\", "");
        let name = names[names.length - 1];
        // define the input params for generate see the rest doc for details
        // https://developers.arcgis.com/rest/users-groups-and-items/generate.htm
        const params = {
          name: name,
          maxRecordCount: 1000,
          enforceInputFileSizeLimit: true,
          enforceOutputJsonSizeLimit: true
        };
        // generalize features to 10 meters for better performance
        params.generalize = true;
        params.maxAllowableOffset = 10;
        params.reducePrecision = true;
        params.numberOfDigitsAfterDecimal = 0;

        let filetypeext;
        if (fileName.indexOf(".json") !== -1) {
          filetypeext = "geojson"
        }
        else {
          filetypeext = "shapefile"
        }

        const myContent = {
          filetype: filetypeext,
          publishParameters: JSON.stringify(params),
          f: "json"
        };

        // use the REST generate operation to generate a feature collection from the zipped shapefile
        esriRequest(portalUrl + "/sharing/rest/content/features/generate", {
          query: myContent,
          body: document.getElementById("uploadForm"),
          responseType: "json"
        }).then(response => {

        const layerName =
          response.data.featureCollection.layers[0].layerDefinition.name;
          featureCollection = response.data.featureCollection;
          let that = this;
          addShapefileToMap();
        })
          .catch(errorHandler);
      }

      function errorHandler(error) {
        console.log(error);
      }

      function addShapefileToMap() {
        console.log("TNNNNNNaddShapefileToMap");
        // add the shapefile to the map and zoom to the feature collection extent
        // if you want to persist the feature collection when you reload browser, you could store the
        // collection in local storage by serializing the layer using featureLayer.toJson()
        // see the 'Feature Collection in Local Storage' sample for an example of how to work with local storage
        let sourceGraphics = [];
        geoJsonObject = {
          type: "FeatureCollection",
          features: []
        }
        console.log('geoJsonObject before adding properties');
        console.log(geoJsonObject);
        featureCollection.layers.forEach(function (layer) {
          layer.featureSet.features.forEach(function (feature) {
            let feat = arcgisToGeoJSON(feature);
            geoJsonObject.features.push(feat);
          });
        });
        cleanupGeoJson(); 
        //Show json and zip file on map
        let layers = featureCollection.layers.map(function (layer) {
          let graphics = layer.featureSet.features.map(function (feature) {
            return Graphic.fromJSON(feature);
          });
          sourceGraphics = sourceGraphics.concat(graphics);
          let featureLayer = new FeatureLayer({
            objectIdField: "FID", //TNN FID not found in upload file  OBJECTID instead
            source: graphics,
            fields: layer.layerDefinition.fields.map(function (field) {
              return Field.fromJSON(field);
            })
          });
          return featureLayer;
          // associate the feature with the popup on click to enable highlight and zoom to
        });
        map.addMany(layers);
        view.goTo(sourceGraphics).catch(function (error) {

          if (error.name != "AbortError") {
            console.error(error);
          }
        });

      }

    });
  }

  onViewLoaded = (view) => {
    console.log("view loaded!")
  };

  onChange(file) {
    console.log(file);
    file.indexOf(".zip") !== -1 ? console.log("zip file!") : console.log("No zip file");
  }

  componentWillUnmount() {
    if (this.view) {
      // destroy the map view
      this.view.container = null;
    }
  }

  toggleConsent = () => {
    if (document.getElementById("consent").checked == true) {  
        document.getElementById("certify").className = "submit-button";  
    } 
    else { 
        document.getElementById("certify").className = "submit-button-disable"; 
    }
  };

  toggleConsentWwtp = () => {
    if (document.getElementById("consentWwtp").checked == true) {  
        document.getElementById("certifyWwtp").className = "submit-button";  
    } 
    else { 
        document.getElementById("certifyWwtp").className = "submit-button-disable"; 
    }
  };

  checkSubmit = () => { 
    let submitReady = true;
    for (const key in this.state.wwtpData) {
      if (this.state.wwtpData.hasOwnProperty(key)) {        
        //if  (this.state.wwtpData[key].status !== 'Not Within Boundary')  {
          /* if (!document.getElementById(this.state.wwtpData[key].facilityWdid).checked) {
            submitReady = false;
            break;
          }
          else { */
            if (!document.getElementById(`${this.state.wwtpData[key].attributes.WWTP_WDID}_Confirm`).checked && !document.getElementById(`${this.state.wwtpData[key].attributes.WWTP_WDID}_Pending`).checked) 
            {
              submitReady = false;
              break;
            }
          //}
        //}
      }
    }
    if (submitReady) {  
      document.getElementById("wwtpSubmit").className = "submit-button";  
    } 
    else {
      document.getElementById("wwtpSubmit").className = "submit-button-disable";
    }
  };

  changeWwtp = (facilityId) => {  
    // WWTP symbol definitions
    let selectedPoint;
    let basePoint;
    this.view.graphics.items.forEach(function(wwtp){         
          if (wwtp.attributes.wwtp_facility_id == facilityId) {
            // Selected symbol
            if (document.getElementById(wwtp.attributes.wwtp_facility_id+'_Confirm').checked) {   
                selectedPoint = SelectedConfirmPoint;
            } else if (document.getElementById(wwtp.attributes.wwtp_facility_id+'_Pending').checked) {
                selectedPoint = SelectedPendingPoint;
            } else {
                selectedPoint = SelectedNWBPoint;
            }
            wwtp.symbol =  new CIMSymbol({data:selectedPoint});
          }
          else {
            // Based symbol
            if (document.getElementById(wwtp.attributes.wwtp_facility_id+'_Confirm').checked) {
                basePoint = ConfirmPoint;
            } else if (document.getElementById(wwtp.attributes.wwtp_facility_id+'_Pending').checked) {
                basePoint = PendingPoint;
            } else {
                basePoint = NWBPoint;
            }
            wwtp.symbol =  new CIMSymbol({data:basePoint});            
          }
    }); 
    this.setState({ jobStatus: 'complete', jobMessage: 'Focus on the WWTP point on map.' }); 
  };

  selectCP = (facilityId, index) => { 
    if (!document.getElementById(facilityId).checked)  {
        alert('Please select the radio check box to review the WWTP point on the map before selecting Confirm or Pending.');
        return false;
    } 
    let cpFeatures = this.state.wwtpData;  
    if (document.getElementById(facilityId+'_Confirm').checked) 
    {
        cpFeatures[index].status= 'C';
    } else {
        cpFeatures[index].status= 'P';
    }

     // WWTP symbol definitions
    let selectedPoint; 
    let basePoint; 
    this.view.graphics.items.forEach(function(wwtp){
          //console.log('Before: ', wwtp.symbol.data.symbol.symbolLayers[0].markerGraphics[0].symbol.symbolLayers[1]);
          if (wwtp.attributes.wwtp_facility_id == facilityId) {
            // Selected symbol
            if (document.getElementById(wwtp.attributes.wwtp_facility_id+'_Confirm').checked) {   
                selectedPoint = SelectedConfirmPoint;
            } else if (document.getElementById(wwtp.attributes.wwtp_facility_id+'_Pending').checked) {
                selectedPoint = SelectedPendingPoint;
            } else {
                selectedPoint = SelectedNWBPoint;
            }
            wwtp.symbol =  new CIMSymbol({data:selectedPoint});
          }
          else {
            // Based symbol
            if (document.getElementById(wwtp.attributes.wwtp_facility_id+'_Confirm').checked) {
                basePoint = ConfirmPoint;
            } else if (document.getElementById(wwtp.attributes.wwtp_facility_id+'_Pending').checked) {
                basePoint = PendingPoint;
            } else {
                basePoint = NWBPoint;
            }
            wwtp.symbol =  new CIMSymbol({data:basePoint});
            //console.log('After assign (Based symbol) = ', wwtp.symbol.data.symbol.symbolLayers[0].markerGraphics[0].symbol.symbolLayers[1]);
          }
    });
    //console.log('Before refresh screen = ', this.view.graphics.items);
    this.setState({ wwtpData:cpFeatures });
    //this.checkSubmit();
  };

  render() {

    return (<div>
      {/* <div style={{ width:'100%', textAlign:'center', backgroundColor : 'red', color : 'white' }} hidden={ (this.state.action != 'Replace') && (this.state.action != 'Upload') && (this.state.action != 'Review') } >
        This map is currently experiencing display refresh issues, but the tool is functioning correctly. After submitting your boundary (per <a href="https://www.waterboards.ca.gov/water_issues/programs/sso/docs/2025/s4l-guide.pdf#page=9" target="_blank">page 9 of the Guidance Document</a>), you may manually refresh the page (via your browser or the F5 button on your keyboard) to view your submitted boundary on the map. You can then click the "Next" button to skip ahead to the WWTP module.
      </div> */}

      {/* Map Main content */}
      <div style={{ minHeight: '85vh', width:'65%', float : 'left' }} ref={this.mapRef} /> 

      {/* Left Panel content */}
      <React.Fragment>
        <Styles>
          <Card className="text-center">
            <Card.Header>
              <Card.Title  hidden={this.state.jobStatus === 'complete' /* || !this.state.jobMessage  */} > {this.state.validFile ? 'Review' : this.state.action} Sewer System Boundary </Card.Title>
            </Card.Header>
            <Card.Body>
            <p hidden={!this.state.selectedFile || !this.state.validFile || this.state.jobStatus === 'complete'}>Click "Submit" to confirm that the boundary displayed on the map is correct for the sewer system listed below: </p>
             <Card.Text /* hidden={this.state.jobStatus === 'complete'} */ style={{ backgroundColor: '#F8F8F8' }} > <b> {localStorage.getItem('s4l_wdid')} - {localStorage.getItem('s4l_csname')} </b> </Card.Text>
              <div>
                <div id="stepper1" className="bs-stepper">
                  <div className="bs-stepper-header">
                    <div className="step" data-target="#test-l-1">
                      <button className="step-trigger">
                      </button> 
                    </div>
                    {/* <div className="line"></div> */}
                    <div className="step" data-target="#test-l-2">
                      <button className="step-trigger">
                      </button>
                    </div>
                    {/* <div className="line"></div> */}
                    <div className="step" data-target="#test-l-3">
                      <button className="step-trigger">
                      </button>
                    </div>
                  </div>

                  <div className="bs-stepper-content">
                    <div id="test-l-1" className="content">                      
                      <div hidden={this.state.action === "Certify" || this.state.action === "WWTP" || this.state.jobStatus === 'complete'}>                        
                        <p hidden={this.state.validFile} >
                          Click “{this.state.action} File” to begin the process by browsing to a boundary file with extension *.zip, *.kmz, or *.kml" 
                                                <br/>  <br/>
                          <p hidden={this.state.action !== "Replace"} > Click “Next” to begin the wastewater treatment plant location process. </p>
                          <p hidden={this.state.jobStatus === 'complete' || !this.state.validateFileMessage} className="text-center"><span className="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span></p>
                          <p className="text-center" style={{ color: "#007bff" }} dangerouslySetInnerHTML={{ __html: this.state.validateFileMessage }}></p>
                          <Uploadbutton onChange={this.onChange.bind(this)} accept=".kml,.kmz,.zip" buttonName={this.state.action} id="uploadformbutton"></Uploadbutton>
                          <form onSubmit={this.onSubmit} hidden={this.state.action !== "Replace"}  >
                            <b className="submit-button" id="wwtpUpload"><p id="titleappend"> &nbsp; &nbsp; &nbsp; &nbsp; Next &nbsp; &nbsp; &nbsp; &nbsp; </p></b> 
                          </form>
                          {/* <b hidden={this.state.action !== "Replace"} className="submit-button" onClick={() => window.location.href = "/s4l/"}> &nbsp; &nbsp; &nbsp; &nbsp; Next &nbsp; &nbsp; &nbsp; &nbsp; </b> */}
                        </p>  
                        <p hidden={!this.state.validFile} >                     
                          <p> Click "Return to Previous Page" to upload a different boundary. </p>
                         {/*  <i hidden={!this.state.validFile} className="fas fa-arrow-circle-right text-center" onClick={() => this.stepper.next()}></i> */}
                          <p hidden={this.state.jobStatus === 'complete' || !this.state.jobMessage} className="text-center"><span className="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span></p>
                          <p className="text-center" style={{ color: "#007bff" }} dangerouslySetInnerHTML={{ __html: this.state.jobMessage }}></p>
                          <form onSubmit={this.onSubmit} hidden={this.state.jobMessage || this.state.action === 'Update'}>
                            <b className="submit-button" id="upload"><p id="titleappend">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Submit &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; </p></b> 
                          </form>
                          <b className="submit-button" onClick={() => window.location.href = "/s4l/map"}> Return to Previous Page </b>
                        </p>
                      </div>

                      <div  hidden={this.state.action !== "Certify" || this.state.jobStatus === 'complete'}   >                         
                        <p>                                               
                          <p align="left"> <input type="checkbox" className="checkbox" id="consent"  onClick={this.toggleConsent} />  &nbsp;
                            <b>I certify under penalty of perjury under the laws of the State of California that the electronically submitted information was prepared under my direction or 
                            supervision. Based on my inquiry of the person(s) directly responsible for gathering the information, to the best of my knowledge and belief, the information 
                            submitted is true, accurate, and complete, and complies with the Statewide Sanitary Sewer Systems General Order. I am aware that there are significant penalties 
                            for submitting false information. </b> </p>                       
                          <form onSubmit={this.onSubmit} hidden={this.state.jobMessage || this.state.action === 'Update'}>
                            <b className="submit-button-disable" id="certify"><p id="titleappend">&nbsp; &nbsp; &nbsp; &nbsp; Certify System Boundary &nbsp; &nbsp; &nbsp; &nbsp; </p></b> 
                          </form>
                          <form onSubmit={this.onSubmit} >
                            <b className="submit-button" id="toCertifyWwtp1"><p id="titleappend"> &nbsp; &nbsp; &nbsp; &nbsp; Skip to Certify WWTP(s) &nbsp; &nbsp; &nbsp; &nbsp; </p></b> 
                          </form>
                        {/*   <b className="submit-button" onClick={() => window.location.href = "/s4l/editor-home"}> &nbsp; &nbsp; &nbsp; &nbsp; Skip to Certify WWTP(s) &nbsp; &nbsp; &nbsp; &nbsp; </b> */}
                        </p>
                      </div>

                      <div hidden={!(this.state.action === "WWTP" || this.state.action === "WWTP_SAVE_SUCCESS") || this.state.action === "Certify" || this.state.jobStatus !== 'complete'}>                         
                        <p> 
                          <div hidden={ this.state.action === "WWTP_SAVE_SUCCESS" } >
                            {
                             (this.state.noWwtpInside === false) ? 
                                "Please select and confirm each wastewater treatment plant (WWTP) location that falls within the uploaded boundary:" 
                                :
                                "None of the wastewater treatment plant(s) (WWTP) from your most recent Annual Report are located within the uploaded boundary:"
                            }
                          </div>
                          <div hidden={ this.state.action === "WWTP" } >
                            {
                             "Wastewater treatment plant (WWTP) location information has been successfully updated.​"
                            }
                          </div>
                          <br/> <br/>

                         <table style={{ border: '1px solid', width: '100%' }}  >
                            <thead>
                              <tr>
                                <th hidden={this.state.action === "WWTP_SAVE_SUCCESS"} style={{ padding:'10px' }} > Selection </th>
                                <th>WWTP WDID</th>
                                <th>WWTP Name</th>
                                <th style={{ width: '40%' }}>Status &nbsp;   
                                    <div class="image-container">
                                        <img src="./question.png" alt="Hover Image" class="hover-image" id="imageHover" />
                                        <div class="popup-window" id="popupWindow" style={{ width: '250px' }} >
                                          <ul>
                                            <li>If the WWTP location is correct, select “Confirm”. </li>
                                            <li>If the WWTP location is:
                                               <ul>
                                                  <li>incorrect, or;</li>
                                                  <li>you need additional time for review,</li> 
                                               </ul>
                                            </li>
                                            <li style={{ listStyleType: 'none' }}>maintain the “Pending” status and contact <a href="mailto:SanitarySewer@waterboards.ca.gov?subject=Help with incorrect WWTP location">SanitarySewer@waterboards.ca.gov</a> for support.</li> 
                                            <li>If the WWTP location is not shown, verify your Annual Report and contact <a href="mailto:SanitarySewer@waterboards.ca.gov?subject=Help with incorrect WWTP location">SanitarySewer@waterboards.ca.gov</a> for additional support.​
                                            </li>
                                          </ul>
                                        </div>
                                    </div>
                                </th>                                
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.wwtpData.map((item, index) => (
                                <tr key={item.attributes.OBJECTID}>
                                  <td hidden={this.state.action === "WWTP_SAVE_SUCCESS"} >
                                    <input type="radio" disabled={false} className="radio" id={item.attributes.WWTP_FACILITY_ID} name="mapFocus"  onChange={() => this.changeWwtp(item.attributes.WWTP_FACILITY_ID)} />
                                  </td>
                                  <td>{item.attributes.WWTP_WDID}</td>
                                  <td>{item.attributes.WWTP_FACILITY}</td>
                                  <td>   
                                    <div hidden = {/* this.state.noWwtpInside || */ this.state.action === "WWTP_SAVE_SUCCESS"  ||  (item.status === 'N')  } >                                                                      
                                      <input  type="radio"  className="radio"  value ='C' checked={item.status === 'C'}   
                                         id={`${item.attributes.WWTP_FACILITY_ID}_Confirm`} name={`${item.attributes.WWTP_FACILITY_ID}_Status`} onChange={() => this.selectCP(item.attributes.WWTP_FACILITY_ID, index)} /> &nbsp; Confirm 
                                      &nbsp; &nbsp; &nbsp; &nbsp;
                                      <input  type="radio"  className="radio"  value ='P' checked={item.status === 'P'} 
                                         id={`${item.attributes.WWTP_FACILITY_ID}_Pending`} name={`${item.attributes.WWTP_FACILITY_ID}_Status`} onChange={() => this.selectCP(item.attributes.WWTP_FACILITY_ID, index)} /> &nbsp; Pending
                                    </div>
                                    <div hidden = {/* ( !this.state.noWwtpInside) || */  (item.status !== 'N') ||  this.state.action === "WWTP_SAVE_SUCCESS" } >                                                                      
                                        Not Within Boundary                                    
                                    </div>
                                    <div hidden = { this.state.action === "WWTP" } >                                                                      
                                       {item.status === 'P'? 'Pending': (item.status === 'C')? 'Confirmed' : 'Not within boundary'}                                    
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>                          
                          <br/>
                          <div hidden={ this.state.action === "WWTP_SAVE_SUCCESS" } >
                            <div hidden = {this.state.noWwtpInside} >
                                <p> Once all wastewater treatment plant location(s) within the system boundary have been assigned a status, click “Submit” to save the status(es)</p>  
                                <p> Or </p>      
                                <p> Click “Cancel” to start over at the system selection page. </p>   
                                <p> Note: Your work will not be saved if you click “Cancel”. ​</p>                                                       
                                <form onSubmit={this.onSubmit} /* hidden={this.state.jobMessage || this.state.action === 'Update'} */ >
                                  <b className="submit-button" id="wwtpSubmit"><p id="titleappend">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Submit &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; </p></b> 
                                </form>
                                <b className="submit-button" onClick={() => window.location.href = "/s4l/editor-home"}>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Cancel &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; </b>
                            </div>
                            <div hidden =  {!this.state.noWwtpInside} >
                                <p> If all wastewater treatment plant location(s) are displayed correctly, in accordance with the <a href="https://www.waterboards.ca.gov/board_decisions/adopted_orders/water_quality/2022/wqo_2022-0103-dwq.pdf" target="_blank"> ​Electronic Sanitary Sewer System Service Area Boundary Map Formatting Requirements</a>, ​no further action is required for wastewater treatment plant location(s).​</p>  
                                <p> If a wastewater treatment plant location is incorrectly marked “Not within boundary” and the wastewater treatment plant location is actually within the boundary, contact <a href="mailto:SanitarySewer@waterboards.ca.gov?subject=Help with incorrect WWTP location">SanitarySewer@waterboards.ca.gov</a> for support before returning to this page.​ </p>
                                <p> A Legally Responsible Official (LRO) must certify the boundary to fulfill section 5.14 of the Sanitary Sewer Systems Order. To do this, an LRO can use the "Start Over" icon in the header to return to the system and action (upload or certify) selection page.</p>
                            </div>
                          </div> 
                          <div hidden={ this.state.action === "WWTP" } >
                            <div >
                                <p>The Legally Responsible Official must certify the boundary and wastewater treatment plant location information to fulfill section 5.14 of the <a target="_blank" href="https://www.waterboards.ca.gov/board_decisions/adopted_orders/water_quality/2022/wqo_2022-0103-dwq.pdf"> Sanitary Sewer Systems Order</a> requirements.​</p>
                                <div hidden={ this.state.userRole !== "Certifier" } >
                                  <p>Click “Certify” below to certify the wastewater treatment plant location(s)</p>
                                  <p> Or </p> 
                                </div>
                                <p> Click the “Start Over” icon in the header bar to return to the system and action (upload or certify) selection page​</p>  
                                <p> Or </p>      
                                <p> Click “Logout” if you are done.​ </p>  
                                <div hidden={ this.state.userRole !== "Certifier" } >                                                 
                                  <form onSubmit={this.onSubmit} /* hidden={this.state.jobMessage || this.state.action === 'Update'} */ >
                                    <b className="submit-button" id="toCertifyWwtp2"><p id="titleappend">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Certify &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; </p></b> 
                                  </form>
                                </div>
                            </div>
                          </div>
                        </p>
                      </div>

                      <div hidden={this.state.jobStatus !== 'complete' || (this.state.action.indexOf("WWTP") !== -1) /* || this.state.action === "Upload" || this.state.action === "Replace" || this.state.action === "Certify" */}>
                          { this.state.jobMessage && this.state.jobMessage.includes('Congratulations') &&  "Your boundary has been successfully"  }

                          { this.state.jobMessage && this.state.jobMessage.includes('Congratulations') ? ((this.state.action === "Certify") ? " certified." : " uploaded.") : ""  }

                          { this.state.jobMessage && !this.state.jobMessage.includes('Congratulations') && <p className="text-center" style={{ color: "#007bff" }} dangerouslySetInnerHTML={{ __html: this.state.jobMessage }}></p>   }
                    
                          <br/><br/>
                          {this.state.action === "Certify" ? "" : <> A LRO must certify the boundary to fulfill section 5.14 of the <br/> <a target="_blank" href="https://www.waterboards.ca.gov/board_decisions/adopted_orders/water_quality/2022/wqo_2022-0103-dwq.pdf"> Sanitary Sewer System Order</a>.<br/><br/> </> }                          
                          Click "Next" to verify wastewater treatment plant location(s)  
                          <br/>
                          Or 
                          <br/>
                          Click the “Start Over” icon in the header bar to <br/>
                          return to the system selection page. <br/>
                          <form onSubmit={this.onSubmit} /* hidden={this.state.jobMessage || this.state.action === 'Update'} */  >
                            <b className="submit-button" id="wwtpCertify"><p id="titleappend">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Next &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; </p></b> 
                          </form>                    
                      </div>

                      <div  style={{ display : (this.state.action === "WWTP_NOAR")? "block" : "none" }}   >   
                            <h5> <b> No Annual Report was found for this system. </b> </h5>
                            <p> Please login to <a target="_blank" href="https://ciwqs.waterboards.ca.gov"> CIWQS</a> and certify your Annual Report before returning to this page​.</p>
                            <p> Consult the 
                              <a target="_blank" href="https://www.waterboards.ca.gov/water_issues/programs/sso/docs/2024/submitting-annual-report-in-CIWQS.pdf"> guidance for submitting the Annual Report</a> as required by section 5.13.2 of the
                              Sanitary Sewer Systems Order.​
                            </p>
                            <p> Click “Start Over” in the header bar to return to the system selection screen​ </p>
                            <p> Or​ </p>
                            <p> Click “Logout” if you are done for now.​   </p>                   
                      </div>

                      <div  style={{ display : (this.state.action === "WWTP_AR_NOWWTP")? "block" : "none" }}   >   
                            <p>In your most recent Annual Report shown below, ​you did not specify a valid WDID number for the wastewater treatment plant(s) receiving discharges from this sewer system, or coordinates are not available in CIWQS for the wastewater treatment plant accepting system waste.</p>
                            <p>Please amend Annual Report <a target="_blank" href={this.state.reportLink} >{this.state.reportType}​</a> in CIWQS.​</p>
                            <p> 
                            <table style={{ border: '1px solid', width: '100%' }}  >
                                <tr>
                                  <td>Report Id</td>
                                  <td>{this.state.reportType}</td>
                                </tr>
                                <tr>
                                  <td>Year</td>
                                  <td>{this.state.reportYear}</td>
                                </tr>
                              </table>
                            </p> 
                            <p> If you don’t see a wastewater treatment plant you expect, contact <a href="mailto:SanitarySewer@waterboards.ca.gov?subject=Help with incorrect WWTP location">SanitarySewer@waterboards.ca.gov</a> for support.​</p>                          
                            <p> Click “Start Over” in the header bar to return to the system selection screen​ </p>
                            <p> Or​ </p>
                            <p> Click “Logout” if you are done.​   </p>                   
                      </div>

                      <div  style={{ display : (this.state.action === "WWTP_CERTIFY")? "block" : "none" }}   >    
                        <div hidden = {Object.keys(this.state.wwtpData.filter(object => object.status === 'C')).length > 0} >
                          <p> <b> No wastewater treatment plant location(s) have been marked as “Confirmed” for this sanitary sewer system.​  </b> </p>
                          <p>If the wastewater treatment plant location(s) associated with this system were correctly identified as “Not within boundary”, then this wastewater treatment plant submission is complete per <a target="_blank" href="https://www.waterboards.ca.gov/board_decisions/adopted_orders/water_quality/2022/wqo_2022-0103-dwq.pdf"> Sanitary Sewer Systems Order</a> requirements.​ </p>
                          <p>If the map to the left shows wastewater treatment plant location(s) within the boundary, the location(s) must still be Confirmed. Please refer to the <a target="_blank" href="https://www.waterboards.ca.gov/board_decisions/adopted_orders/water_quality/2022/wqo_2022-0103-dwq.pdf"> Guidance Document</a> if you need assistance. 
                          ​</p>
                        </div>                     
                        <div hidden = {Object.keys(this.state.wwtpData.filter(object => object.status === 'C')).length === 0} >  
                          <p> Please select and review each wastewater treatment plant (WWTP) location for certification: </p>  
                          <table style={{ border: '1px solid', width: '100%' }}  >
                            <thead>
                              <tr>
                                <th hidden={this.state.action === "WWTP_SAVE_SUCCESS"} > Selection </th>
                                <th>WWTP WDID</th>
                                <th>WWTP Name</th>                               
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.wwtpData.map((item) => (
                                <tr key={item.id} hidden = {(item.status !== 'C')} >
                                  <td hidden={this.state.action === "WWTP_SAVE_SUCCESS"} >
                                    <input type="radio" className="radio" id={item.facilityWdid} name="mapFocus"  onChange={() => this.changeWwtp(item.attributes.WWTP_FACILITY_ID)} />
                                  </td>                                 
                                  <td>{item.attributes.WWTP_WDID}</td>
                                  <td>{item.attributes.WWTP_FACILITY}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table> 
                          <br/>                                         
                          <p align="left"> <input type="checkbox" className="checkbox" id="consentWwtp"  onClick={this.toggleConsentWwtp} />  &nbsp;
                            <b>I certify under penalty of perjury under the laws of the State of California that the electronically submitted information was prepared under my direction or supervision. Based on my inquiry of the person(s) directly responsible for gathering the information, to the best of my knowledge and belief, the information submitted is true, accurate, and complete, and complies with the Statewide Sanitary Sewer Systems General Order. I am aware that there are significant penalties for submitting false information. </b> </p>                       
                          <form onSubmit={this.onSubmit} hidden={/* this.state.jobMessage || */ this.state.action === 'Update'}>
                            <b className="submit-button-disable" id="certifyWwtp"><p id="titleappend">&nbsp; &nbsp; &nbsp; &nbsp; Certify &nbsp; &nbsp; &nbsp; &nbsp; </p></b> 
                          </form>
                          <b className="submit-button" onClick={() => window.location.href = "/s4l/editor-home"}> &nbsp; &nbsp; &nbsp; &nbsp; Cancel &nbsp; &nbsp; &nbsp; &nbsp; </b> 
                        </div>
                      </div>

                      <div  style={{ display : (this.state.action === "WWTP_CERTIFY_SUCCESS")? "block" : "none" }}   >    
                          <p> These wastewater treatment plant (WWTP) location(s) have been successfully certified.​ </p>  
                          <table style={{ border: '1px solid', width: '100%' }}  >
                            <thead>
                              <tr>
                                <th>WWTP WDID</th>
                                <th>WWTP Name</th>                               
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.wwtpData.map((item) => (
                                <tr key={item.id} hidden = {(item.status !== 'C')} >
                                  <td>{item.attributes.WWTP_WDID}</td>
                                  <td>{item.attributes.WWTP_FACILITY}</td>                                  
                                </tr>
                              ))}
                            </tbody>
                          </table> 
                          <br/> 
                          <p>Please make sure this boundary is certified. To certify, use the "Start Over" icon in the header bar to return to the system and action (upload or certify) selection page.</p>                                        
                         
                          <p>Click the “Start Over” icon in the header to work on another sanitary sewer system​ </p>
                          <p>Or​ </p>
                          <p>Click the “Logout” icon if you are done.​ </p>
                      </div>
                    </div>

                    <div id="test-l-2" className="content">
                    </div>

                    <div id="test-l-3" className="content text-center">
                    </div>

                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>  
        </Styles>
      </React.Fragment>   
    </div>

    );

  }
}


